import React, { useState } from 'react'
import styled from 'styled-components'
import { useNavigate, useParams } from 'react-router'
import { useMutation } from '@apollo/client'
import { Replay as ReplayIcon, Delete as DeleteIcon } from '@mui/icons-material'

import { backgroundGray, navy } from '../../layout/colors'
import removeFoodFromOffer from '../../mutations/v2/removeFoodFromOffer'
import canteen from 'src/queries/v2/canteen'
import useLogin from '../../hooks/useLogin'
import Modal from './Modal'
import { UserAdminLevel } from 'src/constants/constants'
import { routes } from 'src/constants/routes'

export interface FoodType {
  name?: string
  id: number
  tags: {
    name: string
  }[]
}

interface Props {
  food: any
  offerId: number
  canteenUserId?: number
  color?: string
}

const Food = ({ food, offerId, canteenUserId, color }: Props) => {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const { user } = useLogin()
  const [deleted, setDeleted] = useState<any>([])
  const [modalOpened, setModalOpened] = useState(false)

  const refetchQueries = {
    refetchQueries: [{ query: canteen, variables: { id: parseInt(id!) } }],
  }

  const [req] = useMutation(removeFoodFromOffer, {
    ...refetchQueries,
  })

  function handleDelete(foodId: number) {
    req({ variables: { data: { foodId, offerId } } })
    setDeleted([...deleted, foodId])
  }

  return (
    <>
      {food.length !== 0 ? (
        food.map((pokrm: FoodType, i: number) => {
          if (deleted.includes(pokrm.id)) return <></>
          return (
            <>
              <Row>
                <Td onClick={() => navigate(routes.foodDetail(pokrm.id))}>Oběd {i + 1}</Td>
                <Td onClick={() => navigate(routes.foodDetail(pokrm.id))}>{pokrm.name}</Td>
                <Td>
                  {user &&
                    (user.id === canteenUserId || user.adminLevel == UserAdminLevel.SUPERADMIN) && (
                      <OpenModal
                        onClick={() => {
                          setModalOpened(true)
                        }}
                        bgColor={color}
                      />
                    )}
                </Td>
                <Td>
                  {user &&
                    (user.id === canteenUserId ||
                      user.adminLevel === UserAdminLevel.SUPERADMIN) && (
                      <Delete
                        onClick={() => {
                          handleDelete(pokrm.id)
                        }}
                        bgColor={color}
                      />
                    )}
                </Td>
              </Row>
              {modalOpened && (
                <Modal setModalOpened={setModalOpened} tags={pokrm.tags.map((tag) => tag.name)} />
              )}
            </>
          )
        })
      ) : (
        <Row>
          <Td>Nic v nabídce</Td>
          <Td></Td>
          <Td></Td>
        </Row>
      )}
    </>
  )
}

export default Food

const Row = styled.tr`
  &:nth-child(odd) {
    background-color: ${backgroundGray};
  }

  &:hover {
    background-color: #e9e9e9;
  }
`

const Td = styled.td`
  padding: 5px 10px;
  cursor: pointer;

  &:first-child {
    width: 100px;
  }

  &:last-child {
    display: flex;
    justify-content: flex-end;
  }
`

interface DeleteIconProps {
  bgColor?: string
}

const Delete = styled(DeleteIcon)<DeleteIconProps>`
  color: ${(props) => props.bgColor || navy};
`

const OpenModal = styled(ReplayIcon)<DeleteIconProps>`
  color: ${(props) => props.bgColor || navy};
`
